import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { Dropdown, MoreIconVertical } from '@dreryk/react-components';
import { getCustomFormattingContext, patientNameFormatter } from '@dreryk/react-common';

import { WaitlistEntryRemoveModalOpener } from '../../../remove/WaitlistEntryRemoveModal.opener';
import { WaitlistEntryUpdateModalOpener } from '../../../update/WaitlistEntryUpdateModal.opener';

import { OpenEntryEditModalDropdownItem } from './OpenEntryEditModalDropdownItem';
import { RemoveEntryDropdownItem } from './RemoveEntryDropdownItem';
import { SuspendEntryDropdownItem } from './SuspendEntryDropdownItem';

type AdditionalOptionsCellProps = {
   waitlistEntry: WaitlistEntry;
};

export const AdditionalOptionsCell = (props: AdditionalOptionsCellProps): ReactElement => {
   return (
      <WaitlistEntryUpdateModalOpener waitlistEntry={props.waitlistEntry}>
         {({ openModal: openEntryUpdateModal }) => (
            <WaitlistEntryRemoveModalOpener
               entryId={props.waitlistEntry.id}
               patientFullName={
                  patientNameFormatter(
                     props.waitlistEntry.patient,
                     getCustomFormattingContext({ options: { order: 'firstLast' } })
                  ) ?? ''
               }
            >
               {({ openModal: openEntryRemoveModal }) => (
                  <Dropdown testId={'additionalOptions'} triggerIcon={<MoreIconVertical />} triggerIconSuffixHidden>
                     <OpenEntryEditModalDropdownItem
                        onClick={openEntryUpdateModal}
                        disabled={
                           props.waitlistEntry.status === 'REGISTERED' ||
                           props.waitlistEntry.status === 'CONFIRMED' ||
                           props.waitlistEntry.status === 'COMPLETED' ||
                           props.waitlistEntry.status === 'REMOVED'
                        }
                     />
                     <SuspendEntryDropdownItem
                        appointmentId={props.waitlistEntry.appointmentId}
                        entryId={props.waitlistEntry.id}
                        entryStatus={props.waitlistEntry.status}
                        disabled={
                           props.waitlistEntry.status !== 'PENDING' && props.waitlistEntry.status !== 'REGISTERED'
                        }
                     />
                     <RemoveEntryDropdownItem
                        onClick={openEntryRemoveModal}
                        disabled={
                           props.waitlistEntry.status === 'CONFIRMED' ||
                           props.waitlistEntry.status === 'REGISTERED' ||
                           props.waitlistEntry.status === 'REMOVED'
                        }
                     />
                  </Dropdown>
               )}
            </WaitlistEntryRemoveModalOpener>
         )}
      </WaitlistEntryUpdateModalOpener>
   );
};
